import Cea from '@app/UiElements/Custom/Cea'
import Ciipa from '@app/UiElements/Custom/Ciipa'

export default function install(Vue) {
  Vue.component('cea', Cea)
  Vue.component('ciipa', Ciipa)
}
